import type { ModulePermissionShape } from "@/types/permissions";

export const agreementPermissionKeys = [
  "agreements_confirm",
  "agreements_reject",
  "agreements_comment",
  "agreements_complete",
  "agreements_amend_data",
  "agreements_amend_tax_status",
  "agreements_amend_content",
  "agreements_statements_update",
  "agreements_delete",
  "agreements_documents_read",
  "agreements_paper_confirm_hr",
  "agreements_paper_confirm_recruiter",
] as const;

export type AgreementPermissions = ModulePermissionShape<
  typeof agreementPermissionKeys
>;
